export var AccumUnit;
(function (AccumUnit) {
  AccumUnit["KBYTE"] = "KBYTE";
  AccumUnit["SECONDS"] = "SECONDS";
  AccumUnit["SMS"] = "SMS";
  AccumUnit["MMS"] = "MMS";
  AccumUnit["MINUTES"] = "MINUTES";
})(AccumUnit || (AccumUnit = {}));
export var UNIT_LOCALE;
(function (UNIT_LOCALE) {
  UNIT_LOCALE["KBYTE"] = "\u041A\u0411";
  UNIT_LOCALE["MEGABYTE"] = "\u041C\u0411";
  UNIT_LOCALE["GIGABYTE"] = "\u0413\u0411";
  UNIT_LOCALE["SECONDS"] = "\u0441\u0435\u043A\u0443\u043D\u0434";
  UNIT_LOCALE["MINUTES"] = "\u043C\u0438\u043D\u0443\u0442";
  UNIT_LOCALE["SMS"] = "SMS";
  UNIT_LOCALE["MMS"] = "MMS";
})(UNIT_LOCALE || (UNIT_LOCALE = {}));